// Centralized API Config Helper for SIMRS2 Frontend
// Default Server: Localhost (http://localhost:5000)

export const MAIN_SERVER_URL = "http://202.155.94.169:8080";

export const getApiUrl = () => {
  const saved = localStorage.getItem('apiUrl');
  if (saved && saved.trim()) {
    return saved.trim().replace(/\/+$/, '');
  }
  localStorage.setItem('apiUrl', MAIN_SERVER_URL);
  return MAIN_SERVER_URL;
};

export const setApiUrl = (url) => {
  if (!url || !url.trim()) {
    localStorage.setItem('apiUrl', MAIN_SERVER_URL);
    return MAIN_SERVER_URL;
  }
  let formatted = url.trim();
  if (!formatted.startsWith('http://') && !formatted.startsWith('https://')) {
    formatted = 'http://' + formatted;
  }
  formatted = formatted.replace(/\/+$/, '');
  localStorage.setItem('apiUrl', formatted);
  return formatted;
};
